import "./banner/Banner.css";
import Banner from "./banner/Banner";

import Registration from "./registration/Registration";
import Vendor_Expert_Tabs from "./vendor-expert-tabs/Vendor_Expert_Tabs";
import PopularVendors from "./vendor-expert-tabs/popular_vendors/Popular_Vendors";
import PlumberExperts from "./vendor-expert-tabs/plumber-expert/Plumber_Expert";
import PainterExperts from "./vendor-expert-tabs/painter-experts/Painter_Experts";
import App_Web_Banner from "./app-web-banner/App_Web_Banner";
import Common_Vendor_Card from "../common_components/common-vendor-card/Common_Vendor_Card";
import Banner_2 from "../contact-us/banner_2/Banner_2";


function Home() {
  const isLoggedIn = localStorage.getItem("token");
  return (
    <>
      <div className="Home">
        <Banner />
        <Vendor_Expert_Tabs />
        <Banner_2/>
      </div>
    </>
  );
}

export default Home;
